<div id="map"></div>
<div class="zoom-control">
  <span (click)="zoomIn()"></span>
  <span (click)="zoomOut()"></span>
</div>
<map-multi-areas *ngIf="showMultiAreas" (closeClick)="closeMultiAreas()" [data]="spot_items" [lang]="lang" (saveClick)="savePage($event)"></map-multi-areas>